import React, { useState } from 'react';
import logo from 'images/marca.svg';
import { Dialog, Button } from '../single-page/components/ds';
import '../public/styles/main.scss';
import '../single-page/styles/design-system.css';

const PLAY_STORE_URL = 'https://play.google.com/store/apps/details?id=com.liquidsort.puzzlelogic&hl=pt_BR';

export default function Public() {
  const [iosDialogOpen, setIosDialogOpen] = useState(false);

  return (
    <div className="app" style={{ minHeight: '100vh' }}>
      <header
        className="appbar"
        style={{ paddingTop: 'calc(env(safe-area-inset-top, 0px) + 16px)' }}
      >
        <div className="appbar-left">
          <img src={logo} alt="Esportes da Sorte" style={{ height: 28 }} />
        </div>
      </header>

      <div style={{ padding: '24px 16px 48px', textAlign: 'center' }}>
        <div
          style={{
            fontSize: 36,
            marginBottom: 12,
            filter: 'drop-shadow(0 6px 18px rgba(255, 138, 0, 0.45))',
          }}
        >
          📱
        </div>
        <h1
          style={{
            fontSize: 28,
            fontWeight: 800,
            margin: '0 0 8px',
            letterSpacing: '-0.02em',
          }}
        >
          Baixe o app Esportes da Sorte
        </h1>
        <p
          style={{
            fontSize: 14,
            color: 'rgba(255, 255, 255, 0.78)',
            maxWidth: 320,
            margin: '0 auto 24px',
            lineHeight: 1.5,
          }}
        >
          Toda a experiência de palpites e bolões está disponível dentro do aplicativo
          oficial Esportes da Sorte. Baixe agora pelo seu celular para participar.
        </p>

        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            gap: 10,
            maxWidth: 320,
            margin: '0 auto 32px',
          }}
        >
          <Button onClick={() => setIosDialogOpen(true)}>Baixar na App Store</Button>
          <a
            href={PLAY_STORE_URL}
            target="_blank"
            rel="noreferrer"
            className="cta ghost"
          >
            Baixar no Google Play
          </a>
        </div>

        <div
          style={{
            fontSize: 12,
            color: 'var(--muted)',
            maxWidth: 320,
            margin: '0 auto',
            lineHeight: 1.5,
          }}
        >
          Já tem a conta? Abra o app e acesse a área de palpites para entrar
          automaticamente.
        </div>
      </div>

      <Dialog
        open={iosDialogOpen}
        onClose={() => setIosDialogOpen(false)}
        title="Em breve"
        actions={<Button onClick={() => setIosDialogOpen(false)}>Entendi</Button>}
      >
        Nosso app para iPhone está em produção. Por enquanto, baixe a versão
        Android no Google Play.
      </Dialog>
    </div>
  );
}
